import React,{useEffect, useState} from 'react';
import { Container, Row, Col, Image, Dropdown } from 'react-bootstrap';
import translate from '../../../../translate';
import HtmlModal from './htmlModal';
import termsHTML from './htmls/termsContent.js';
import privacyHTML from './htmls/privacyContent.js'
import FooterLogo from '../../assets/icons/footer-logo.svg';
import FooterLogoMobileW from '../../assets/icons/icono-w.svg';
import WbdWhite from '../../assets/icons/menu-logo-white.svg';
import './footer.css';

const Footer = ({...props}) => {

  const {lan} = props;
  const transl = translate[lan].LandingRedesign.footer;
  const [selectedLanguage, setSelectedLanguage] = useState(props.lan === 'es' ? transl.esp : transl.eng)
  const [showTerms, setShowTerms] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const currentYear = new Date().getFullYear();

  useEffect(() =>{
    setSelectedLanguage(props.lan === 'es' ? transl.esp : transl.eng)
  }, [selectedLanguage, lan])

  return (
    <div className='wrapper-footer'>
      <Container fluid className='custom-wrapper-footer'>
        <Row className='row-web-footer'>
          <Image src={FooterLogo} width={150}/>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-custom-language">
              {selectedLanguage}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item style={{textDecoration: 'none'}} eventKey="1" onClick={()=>{props.changeLan('es'); setSelectedLanguage('Español')}}>{transl.esp}</Dropdown.Item>
              <Dropdown.Item style={{textDecoration: 'none'}} eventKey="2" onClick={()=>{props.changeLan('en'); setSelectedLanguage('Ingles')}}>{transl.eng}</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Row>
        <Row className='white-icon-mobile'>
          <Image src={FooterLogoMobileW} width={50} className='logo-mobile-view'/>
        </Row>
        <Row className="justify-content-between">
          <Col lg={8} md={9} sm={12}>
            <div className="d-flex-mobile">
              <div onClick={() => setShowTerms(true)} className="white-links-terms">{transl.title1}</div>
              <div className="white-links-policy"><a className='link-privacy' href="/privacypolicy">{transl.title2}</a></div>
              <div onClick={() => window.open(window.location.origin + '/faq','_blank')} className='white-links'>{transl.title3}</div>
            </div>
          </Col>
          <Col lg={4} md={3} sm={12} className='footer-social-media-links'>
            <div onClick={()=>window.open('https://www.facebook.com/wirebitdigital','_blank')} className='links-social-media-fb'>Facebook</div>
            <div onClick={()=>window.open('https://www.instagram.com/wirebitdigital/','_blank')} className='links-social-media-inst'>Instagram</div>
            <div onClick={()=>window.open('https://www.linkedin.com/company/wirebit-oficial/mycompany','_blank')} className='links-social-media-linked'>LinkedIn</div>
          </Col>
        </Row>
        <Row className='dropdown-mobile'>
          <Dropdown >
            <Dropdown.Toggle id="dropdown-custom-language">
              {selectedLanguage}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item style={{textDecoration: 'none'}} eventKey="1" onClick={()=>{localStorage.setItem("lan", 'es'); setSelectedLanguage('Español')}}>Español</Dropdown.Item>
              <Dropdown.Item style={{textDecoration: 'none'}} eventKey="2" onClick={()=>{localStorage.setItem("lan", 'en'); setSelectedLanguage('Ingles')}}>Ingles</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Row>
        <div className='wbd-white-mobile-wrapper'>
          <Image src={WbdWhite} className='logo-mobile-view'/>
        </div>
        <div style={{color: '#FFF', marginTop: 50}}>
          {transl.disclaimer}
        </div>
        <div  style={{color: '#FFF', marginTop: 10, marginBottom: 50}}>
        {currentYear} {transl.disclaimer_2}
        </div>
      </Container>

      <HtmlModal
        show={privacy}
        close={()=>setPrivacy(false)}
        html={privacyHTML}
      />
      <HtmlModal
        show={showTerms}
        close={()=>setShowTerms (false)}
        html={termsHTML}
      />
    </div>
  )
}

export default Footer;
